import Marquee from "react-fast-marquee";

const brands = [
  {
    id: 1,
    name: "Google",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
    link: "https://www.google.com",
  },
  {
    id: 2,
    name: "Amazon",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    link: "https://www.amazon.com",
  },
  {
    id: 3,
    name: "Microsoft",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    link: "https://www.microsoft.com",
  },
  {
    id: 4,
    name: "Facebook",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png",
    link: "https://www.facebook.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
  {
    id: 5,
    name: "Apple",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    link: "https://www.apple.com",
  },
];

const PremiumMarquee = () => {
  return (
    <div className="relative w-full bg-[#0F172A] py-10">
      {/* Glass effect background */}
      <div className="absolute inset-0 bg-white/10 backdrop-blur-3xl rounded-xl" />

      <div className="relative w-full max-w-[1400px] mx-auto overflow-hidden px-4">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {brands.map((brand) => (
            <a
              key={brand.id}
              href={brand.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center w-40 h-20 bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg border border-white/20 mx-4 transition-transform duration-300 hover:scale-105"
            >
              <img
                src={brand.image}
                alt={brand.name}
                className="w-auto h-12 object-contain filter brightness-90 group-hover:brightness-100 transition-all duration-300"
              />
            </a>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default PremiumMarquee;
